import structureTypes from 'common/constants/structureTypes'
import ServerPage from 'src/shared/types/server-page-interface'
import { migrateCommand } from '../utils/migrateCommand'
import { migrateRemotePopup } from './migrate-remote-popup'

export default function (page: ServerPage) {
  return migrateCommand({
    page,
    structureType: structureTypes.REMOTE_POPUP,
    migrateFunction: migrateRemotePopup,
  })
}
